export default {
  methods: {
    highlightMatches(text, filter) {
      if (text == null || text.includes('|STRONG|') || text.includes('~END~')) {
        return '';
      }

      let textToReturn = [];
      for (let word of text.split(' ')) {
        let finalWord = word;

        for (const textSearch of filter.split(' ')) {
          if (textSearch.length < 0) {
            continue;
          }

          finalWord = word.replaceAll(
            new RegExp(textSearch.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'ig'),
            (matchedText) => `<strong>${matchedText}</strong>`
          );

          if (finalWord != word) {
            break;
          }
        }

        textToReturn.push(finalWord);
      }

      return textToReturn.join(' ');
    },
  },
};
